export default function ({ app }) {
    app.router.beforeEach((to, from, next) => {
        app.store.commit('globals/emptyNotifications');
        next();
    });
}
